export default class FormCreate
{
    constructor(questionTypeValueToId)
    {
        this.questionTypeValueToId = questionTypeValueToId;
        this.lastMouseDownElement = null;

        // click outside of .form-component
        document.addEventListener('mousedown', this.saveMouseDownElement);
        document.addEventListener('mouseup', this.clickOutsideFormComponent);

        // click to edit an editable
        $('form #form-col').on('click', '.editable', (e) => {
            this.clickEditable(e);
        });

        // click .form-component
        $('form #form-col').on('click', ".form-component", (e) => {
            this.clickFormComponent(e);
        });

        // click 'delete' on a section or question
        $('form #form-col').on('click', '.form-component > .dropdown a.delete', (e) => {
            this.clickDelete(e);
        });

        // click 'move-up' on a section or question
        $('form #form-col').on('click', '.form-component > .dropdown a.move-up', (e) => {
            this.clickMoveUp(e);
        });

        // click 'move-down' on a section or question
        $('form #form-col').on('click', '.form-component > .dropdown a.move-down', (e) => {
            this.clickMoveDown(e);
        });

        // leave an .editable-input
        $('form #form-col').on('blur', '.editable-input', (e) => {
            this.blurEditableInput(e);
        });

        // press enter inside an .editable-input
        $('form #form-col').on('keypress', '.editable-input', (e) => {
            this.enterEditableInput(e);
        });

        // click add section/question menu
        $('form #form-col').on('click', '.form_section > .add.dropdown > .dropdown-menu a', (e) => {
            this.clickAddSectionQuestionLink(e);
        });

        // change question type select
        $('form #form-col').on('change', '.additional select', (e) => {
            this.changeQuestionTypeSelect(e);
        });

        // click on the .add-option to add new response option to a check/radio question
        $('form #form-col').on('click', '.form-check-label.add-option', (e) => {
            this.clickAddResponseOption(e);
        });

        // click on delete response icon
        $('form #form-col').on('click', '.form-check > i.bi-trash-fill', (e) => {
            this.clickDeleteResponseOption(e);
        });

        // set/unset field as required
        $('form #form-col').on('change', 'input.required', (e) => {
            this.changeRequired(e);
        });

        // Add the add (question/section) button to each section
        this.addAddbuttonToAllSections();

        // Make sure every response option has a delete btn
        this.addDeleteOptionToRadioCheck();
    }

    /**
     * clickEditable
     *
     * @param {Object} event
     * @return null
     */
    clickEditable(event)
    {
        let $link  = $(event.currentTarget);
        let $input = $link.next('input');

        $link.addClass('d-none');
        $input.removeClass('d-none')
            .select();
    }

    saveMouseDownElement(event)
    {
        this.lastMouseDownElement = event.target;
    }

    /**
     * clickOutsideFormComponent 
     *
     * When a user clicks outside of a the currently selected form component, close it
     * 
     * @param {Object} event
     * @return null
     */
    clickOutsideFormComponent(event)
    {
        let curSelected = $('div.mb-4.selected')[0];

        // if the mousedown element is an editable input, then we probably just did a drag/highlight 
        // and don't want to fire a real click outside component, so just bail
        if (this.lastMouseDownElement.classList.contains('editable-input')) {
            return false;
        }

        if (curSelected !== undefined && curSelected !== event.target && !curSelected.contains(event.target)) {
            // hide all other selected inputs
            $('.mb-4').removeClass('selected rounded');
            // hide all other additional inputs
            $('.additional').hide();

            // turn editable inputs back into text
            $('.editable').removeClass('d-none');
            $('.editable-input').addClass('d-none');

            // hide all question option menus
            $('.form-component > .dropdown').addClass('d-none');
        }

    }

    /**
     * blurEditableInput 
     * 
     * When you leave an edittable input update the live text.
     *
     * @param {Object} event - the event object
     * @return null
     */
    blurEditableInput(event)
    {
        let $input = $(event.currentTarget);
        let $link  = $input.prev();

        let inputVal = $input.val();

        // Handle an empty input value (we need to show something)
        if (inputVal === '')
        {
            inputVal = '<empty>';
        }

        // Make the input we just changed, match the h3 text
        $link.text(inputVal);
    }

    /**
     * enterEditableInput
     *
     * Do not submit the form on enter, instead send blur event
     *
     * @param {Object} e - the event object
     * @return null
     */
    enterEditableInput(event)
    {
        let $input  = $(event.currentTarget);
        let keycode = (event.keyCode ? event.keyCode : event.which);

        if (keycode == '13')
        {
            $input.blur();
            // Do not submit form
            event.preventDefault();
            return false;
        }
    }

    /**
     * clickAddSectionQuestionLink
     *
     * When you select an option from the dropdown menu, add the new section or question to the dom
     *
     * @param {Object} event
     * @return null
     */
    clickAddSectionQuestionLink(event)
    {
        event.preventDefault();

        let $anchor = $(event.currentTarget);
        let type    = $anchor.attr('data-type');

        let $parentSection = $anchor.closest('.form_section').parent('.form_section');

        if (!type.startsWith('q-'))
        {
            // sub section
            if (type.startsWith('sub')) 
            {
                this.addNewSection($anchor, true);
                return;
            }
            // sibling section (sub section of parent)
            else if ($parentSection.length)
            {
                let $parentAnchor = $parentSection.find('.add a[data-type="subsection"]').first();
                this.addNewSection($parentAnchor, true);
                return;
            }
            // section
            else
            {
                this.addNewSection($anchor);
                return;
            }
        }

        this.addNewQuestion($anchor);
        return;
    }

    /**
     * addAddbuttonToAllSections 
     * 
     * Will add the Add Section/Question button to the end of each section currently on screen
     *
     * @return null
     */
    addAddbuttonToAllSections()
    {
        $('#form-col .form_section').each(function(index) {
            let $addBtn = $('#add-button-template > div').clone();
            $(this).find('> .questions').last().after($addBtn);
        });
    }

    /**
     * addDeleteOptionToRadioCheck 
     * 
     * @return null
     */
    addDeleteOptionToRadioCheck()
    {
        $('.questions > .form-component > .response > .mb-4 > .form-check').each(function(index, check) {
            let $check = $(check);
            let add    = $check.find('label.add-option');

            // don't add a delete option to any add options
            if (add.length)
            {
                return;
            }

            $check.append('<i class="bi-trash-fill"></i>');
        });
    }

    /**
     * clickFormComponent 
     * 
     * Click on the form component anywhere, turn it into edit mode.
     *
     * @param {Object} event
     * @return null
     */
    clickFormComponent(event)
    {
        let $component = $(event.currentTarget).closest('.form-component');

        // hide all other selected form components
        $('.form-component').removeClass('selected rounded');

        // hide all other additional inputs
        $('.additional').hide();

        // hide all editable fields
        $('.editable').removeClass('d-none');
        $('.editable-input').addClass('d-none');

        // hide all question option menus
        $('.form-component > .dropdown').addClass('d-none');

        // set this question as selected
        $component.addClass('selected rounded');

        // show all additional fields for this component
        $component.find('.additional').show();

        // show all the editable fields for this component
        $component.find('.editable').addClass('d-none');
        $component.find('.editable-input').removeClass('d-none');

        // show the question option menu for this component
        $component.find('> .dropdown').removeClass('d-none');
    }

    /**
     * clickDelete
     * 
     * Click on the section/question delete option
     *
     * @param {Object} event
     * @return null
     */
    clickDelete(event)
    {
        let $deleteLink = $(event.currentTarget);
        let $component  = $deleteLink.closest('.form-component');

        event.preventDefault();

        // Make sure we have at least one section/question

        // question
        if ($component.parent().hasClass('questions'))
        {
            if ($component.parent().find('.form-component').length <= 1)
            {
                return false;
            }

            $component.remove();
        }
        // section
        else
        {
            if ($('form #form-col .form_section').length <= 1)
            {
                return false;
            }

            $component.closest('.form_section').remove();
        }

        return false;
    }

    /**
     * clickMoveUp
     * 
     * Click on the section/question move up option
     *
     * @param {Object} event
     * @return null
     */
    clickMoveUp(event)
    {
        let $moveUpLink = $(event.currentTarget);
        let $component  = $moveUpLink.closest('.form-component');

        let $componentParent = $component.parent();

        // Move question
        if ($componentParent.hasClass('questions'))
        {
            // the current index of the question we are moving
            let currentIndex = $component.attr('data-index');
            let desiredIndex = parseInt(currentIndex) - 1;

            // user tried to move top question up (can't go up anymore) just bail
            if (desiredIndex < 0) return;

            // visually move the question up
            $component.insertBefore($component.prev());

            // now swap the question input ids/names with the one above it
            this.updateQuestionIndex($componentParent, currentIndex, -1);
            this.updateQuestionIndex($componentParent, desiredIndex, currentIndex);
            this.updateQuestionIndex($componentParent, -1, desiredIndex);

            event.preventDefault();
            return false;
        }
        // Move section
        else
        {
            alert('Sections cannot be moved.');
        }
    }

    clickMoveDown(event)
    {
        let $moveLink  = $(event.currentTarget);
        let $component = $moveLink.closest('.form-component');

        let $componentParent = $component.parent();

        // Move question
        if ($componentParent.hasClass('questions'))
        {
            // the current index of the question we are moving
            let currentIndex = $component.attr('data-index');
            let desiredIndex = parseInt(currentIndex) + 1;
            let highestIndex = $componentParent.find('.form-component').last().attr('data-index');

            // user tried to move bottom question down (can't go down anymore) just bail
            if (desiredIndex > highestIndex) return;

            // visually move the question down
            $component.insertAfter($component.next());

            // now swap the question input ids/names with the one above it
            this.updateQuestionIndex($componentParent, currentIndex, -1);
            this.updateQuestionIndex($componentParent, desiredIndex, currentIndex);
            this.updateQuestionIndex($componentParent, -1, desiredIndex);

            event.preventDefault();
            return false;
        }
        // Move section
        else
        {
            alert('Sections cannot be moved.');
        }
    }

    /**
     * updateQuestionIndex
     *
     * Will update the id and name of all inputs from one index to another.
     *
     * @param {jQuery} $questionsDiv
     * @param number      currentIndex
     * @param number      desiredIndex
     * @return null
     */
    updateQuestionIndex($questionsDiv, currentIndex, desiredIndex)
    {
        let sectionIndex = $questionsDiv.parent('.form_section').attr('data-index');

        let $formComponent = null;

        $("#form-col [name^='form_section[" + sectionIndex + "][questions][" + currentIndex + "]").each((i, input) => {
            // get the ending part of this inputs id/name
            let idStartIndex   = this.indexOfNth(input.id, '-', 4);
            let nameStartIndex = this.indexOfNth(input.name, ']', 3);

            let idEnding   = input.id.substring(parseInt(idStartIndex) + 1);
            let nameEnding = input.name.substring(parseInt(nameStartIndex) + 1);

            $formComponent = $(input).closest('.form-component');

            // update the input's new id/name
            $(input).attr('id', 'form_section-' + sectionIndex + '-questions-' + desiredIndex + '-' + idEnding)
                .attr('name', 'form_section[' + sectionIndex + '][questions][' + desiredIndex + ']' + nameEnding);
        });

        // update this questions form component index
        $formComponent.attr('data-index', desiredIndex);
    }

    /**
     * indexOfNth
     *
     * Like indexOf, but will get the nth index of.
     *
     * @param string string
     * @param string char
     * @param number nth
     * @param number fromIndex
     * @return number
     */
    indexOfNth (string, char, nth, fromIndex=0) {
        let indexChar = string.indexOf(char, fromIndex);
        if (indexChar === -1){
            return -1;
        } else if (nth === 1) {
            return indexChar;
        } else {
            return this.indexOfNth(string, char, nth-1, indexChar+1);
        }
    }

    /**
     * getNextSectionIndex
     *
     * Will search through the current form sections and return 1 more than the current
     * highest index.
     * 
     * @return int
     */
    getNextSectionIndex()
    {
        let highestSectionIndex = 0;

        $('form #form-col div.form_section').each(function() {
            if (parseInt($(this).attr('data-index')) > highestSectionIndex)
            {
                highestSectionIndex = parseInt($(this).attr('data-index'));
            }
        });

        return highestSectionIndex = highestSectionIndex + 1;
    }

    /**
     * addNewSection 
     * 
     * @param {jQuery} $addAnchor 
     * @param boolean child
     * @param string after
     * @return null
     */
    addNewSection($addAnchor, child = false)
    {
        let $section = $addAnchor.closest('.form_section');
        let sIndex   = this.getNextSectionIndex();

        let id   = 'form_section-' + sIndex + '-';
        let name = 'form_section[' + sIndex + ']';

        let sectionTemplateSelector = '#section-template';
        if (child)
        {
            sectionTemplateSelector = '#subsection-template';
        }

        let $sectionTemplate = $('#templates > ' + sectionTemplateSelector + ' > div').clone();

        // update index of this section
        $sectionTemplate.attr('data-index', sIndex);

        if (child)
        {
            // set the parent section
            $sectionTemplate.find(sectionTemplateSelector + '-parent').val($section.attr('data-index'));
        }

        // update the ids and names
        $sectionTemplate.find(sectionTemplateSelector + '-name').attr('name', name + '[name]');
        if (child)
        {
            $sectionTemplate.find(sectionTemplateSelector + '-parent')
                .attr('name', name + '[parent]')
                .attr('id', id + 'parent');
        }

        // add the add menu to the section
        let $addBtn = $('#add-button-template > div').clone();
        $sectionTemplate.append($addBtn);

        // add the new section
        if (child)
        {
            $section.append($sectionTemplate);
        }
        else
        {
            $section.after($sectionTemplate);
        }

        // now add a default text question to this section
        let $anchor = $sectionTemplate.find('> .add a[data-type="q-radio"]');
        this.addNewQuestion($anchor);
    }

    /**
     * addNewQuestion 
     * 
     * @param {jQuery} $addAnchor 
     * @return null
     */
    addNewQuestion($addAnchor)
    {
        let type      = $addAnchor.attr('data-type');
        let $question = $addAnchor.closest('.add').prev('.questions');
        let qIndex    = $question.find('> div.mb-4').last().attr('data-index');
        let sIndex    = $question.closest('div.form_section').attr('data-index');

        if (qIndex === undefined)
        {
            qIndex = 0;
        }
        else
        {
            qIndex = parseInt(qIndex) + 1;
        }

        let id   = 'form_section-' + sIndex + '-questions-' + qIndex;
        let name = 'form_section[' + sIndex + '][questions][' + qIndex + ']';

        // remove the q- from the front
        type = type.slice(2);

        let $questionTemplate   = $('#templates > #question-' + type + '-template > div').clone();
        let $additionalTemplate = $('#templates > #additional-template > div').clone();

        // update index of this question
        $questionTemplate.attr('data-index', qIndex);

        // remove the empty additional area
        $questionTemplate.find('> div.additional').remove();

        // add the additional area to the question
        $questionTemplate.find('> input.editable-input').after($additionalTemplate);

        // update the ids and names
        $questionTemplate.find('> input.editable-input').attr('name', name + '[question]')
            .attr('id', id + '-question');
        $questionTemplate.find('#additional-template-type').val(this.questionTypeValueToId[type]);
        $questionTemplate.find('#additional-template-type-label').attr('for', id + '-type_id')
            .attr('id', '');
        $questionTemplate.find('#additional-template-type').attr('id', id + '-type_id')
            .attr('name', name + '[type_id]');
        $questionTemplate.find('#additional-template-required-label').attr('for', id + '-required')
            .attr('id', '');
        $questionTemplate.find('#additional-template-required').attr('id', id + '-required')
            .attr('name', name + '[required]');

        switch (type)
        {
            case 'text':
                $questionTemplate.find('.response > .mb-4 > input')
                    .attr('id', id + '-responses-0-response')
                    .attr('name', name + '[responses][0][response]');
                break;

            case 'textarea':
                $questionTemplate.find('.response > .mb-4 > textarea')
                    .attr('id', id + '-responses-0-response')
                    .attr('name', name + '[responses][0][response]');
                break;

            case 'radio':
            case 'checkbox':
                $questionTemplate.find('.response > .mb-4 > .form-check > input[type=text]').each(function(rIndex) {
                    $(this).attr('id', id + '-responses-' + rIndex + '-response')
                        .attr('name', name + '[responses][' + rIndex + '][response]');
                });

                // add delete option to the responses
                $questionTemplate.find('.response > .mb-4 > .form-check:not(:last-child)').append('<i class="bi-trash-fill"></i>');
                break;
        }

        // add the new question
        $question.append($questionTemplate);
    }

    /**
     * changeQuestionTypeSelect
     *
     * Change an additional select, check if it's a question type, then make the dom updates
     *
     * @param {Object} event
     * @return null
     */
    changeQuestionTypeSelect(event)
    {
        let $typeSelect = $(event.currentTarget);
        let selectId    = $typeSelect.attr('id');
        let type        = $typeSelect.find('option:selected').attr('data-type');

        let $section = $typeSelect.closest('.form_section');

        // Change question type
        if (/[0-9]-type_id$/.test(selectId))
        {
            let $additional      = $typeSelect.closest('.additional');
            let $responseWrapper = $additional.next('.response').find('.mb-4');
            let $responseInput   = $responseWrapper.find('input[type=text], textarea');

            let responseId   = $responseInput.attr('id');
            let responseName = $responseInput.attr('name');

            // delete the old response
            $responseWrapper.remove();

            // add a new question of the changed type to this section
            let $anchor = $section.find('> .add a[data-type="q-' + type + '"]');
            this.addNewQuestion($anchor);

            let $newQuestionWrapper = $section.find('.questions > .mb-4').last();
            let $newResponseWrapper = $newQuestionWrapper.find('.response > .mb-4').last();

            // update the new question's response id/name
            $newResponseWrapper.find('> input, > textarea, > .form-check > input[type=text]').first()
                .attr('id', responseId)
                .attr('name', responseName);

            // move the new response to the right spot
            $additional.next('.response').append($newResponseWrapper);

            // delete what's left of the new question
            $newQuestionWrapper.remove();
        }
    }

    /**
     * clickAddResponseOption 
     *
     * Click on the add response option to a radio or checkbox question.
     * 
     * @param {Object} event
     * @return null
     */
    clickAddResponseOption(event)
    {
        let $prevRadioCheck  = $(event.currentTarget).closest('.form-check').prev('.form-check');
        let $wrapper         = $(event.currentTarget).closest('.mb-4');
        let $newRadioCheck   = $prevRadioCheck.clone();

        let id   = $prevRadioCheck.find('> input').last().attr('id');
        let name = $prevRadioCheck.find('> input').last().attr('name');

        // update the index count on the input name
        id   = id.replace(/-(\d+)-response$/, function(full, n) { return '-' + (Number(n) + 1); });
        name = name.replace(/\[(\d+)\]\[response\]$/, function(full, n) { return '[' + (Number(n) + 1) + ']'; });

        $newRadioCheck.find('> input').last()
            .attr('id', id + '-response')
            .attr('name', name + '[response]');

        $prevRadioCheck.after($newRadioCheck);
    }

    /**
     * clickDeleteResponseOption 
     * 
     * @param {Object} event
     * @return null
     */
    clickDeleteResponseOption(event)
    {
        let $formCheck = $(event.currentTarget).closest('.form-check');
        let $response  = $(event.currentTarget).closest('.response');
        let name       = $formCheck.find('input.editable-input').attr('name');

        name = name.slice(0, -10); // remove the [response]

        // we can only delete if we have 3+ responses (1 extra because of the 'Add Response')
        if ($response.find('.form-check > .form-check-input').length <= 2) {
            return;
        }

        // remove the additional id for this response
        $formCheck.siblings('.additional').find('input[name="' + name + '[id]"]').remove();
        // remove the response
        $formCheck.remove();
    }

    /**
     * changeRequired
     *
     * @param {Object} event
     * @return null
     */
    changeRequired(event)
    {
        let $input    = $(event.currentTarget);
        let $editable = $input.closest('.additional').siblings('.editable').first();

        $editable.removeClass('required');

        if ($input.is(':checked')) {
            $editable.addClass('required');
        }
    }

    /**
     * updateAllRequired
     *
     * Will loop through every question and adds a red asterick if the question is set
     * as required.
     */
    updateAllRequired()
    {
        // loop through all questions and show required visual
        $('.questions .form-component').each(function(index, component) {
            let $input    = $(component).find('.additional input.required').first()
            let $editable = $(component).find('h3.editable').first();

            $editable.removeClass('required');

            if ($input.is(':checked')) {
                $editable.addClass('required');
            }
        });
    }
}
